module.exports = __webpack_public_path__ + "img/выгрузить список.a09fff2c.svg";